import { FC } from "react";
import { useTranslation } from "rujira.ui";
import {
  BanxaQuote,
  banxaFeeAmount,
  banxaFeeTotal,
} from "../../services/banxa";
import { BanxaReviewRow } from "./BanxaReviewRow";

const formatFee = (amount: number, fiat: string) =>
  `${new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(amount)} ${fiat}`;

export const BanxaFeeBreakdown: FC<{
  quote?: BanxaQuote;
  fiat: string;
}> = ({ quote, fiat }) => {
  const { t } = useTranslation("common");
  const processingFee = banxaFeeAmount(quote?.processingFee);
  const networkFee = banxaFeeAmount(quote?.networkFee);
  const partnerFee = banxaFeeAmount(quote?.partnerFee);

  return (
    <>
      <BanxaReviewRow
        label={t("banxaProcessingFee")}
        value={formatFee(processingFee, fiat)}
      />
      <BanxaReviewRow
        label={t("networkFee")}
        value={formatFee(networkFee, fiat)}
      />
      {partnerFee !== 0 && (
        <BanxaReviewRow
          label={t("banxaPartnerFee")}
          value={formatFee(partnerFee, fiat)}
        />
      )}
      <BanxaReviewRow
        label={t("banxaFeeTotal")}
        value={formatFee(banxaFeeTotal(quote), fiat)}
      />
    </>
  );
};
